import { Box, Button, Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material'
import WeekPicker from 'components/common/DatePickerCC/WeekPicker'
import { NS_TRANS } from 'constants/common'
import { useTranslation } from 'react-i18next'

/**
 * Thành phần tìm tiếm nâng cao trong cuộc họp
 * @param {*} param0 
 * @returns 
 */
const ItemFilter = ({children, title,isLast = false, ...props}) => {
    return (
        <Box sx={{ borderBottom: isLast ? 'none' : '1px solid #dedede'}} mb={1} {...props}>
            <Typography mb={0.5} fontWeight={700}>{title}</Typography>
            {children}
        </Box>
    )
}

/**
 * Chức năng tìm kiếm nâng cao cho cuộc họp
 * @returns 
 */
const FilterMeeting = ({setDiffTime, currentTypeView, handleChangeTimeInCalendar}) => {
    const { t } = useTranslation(NS_TRANS.BTN)
    return (
        <Box sx={{ width: '80vw', display: 'flex', flexDirection: 'column', padding: '20px 0', justifyContent: 'space-between', height: 1 }}>
            <Stack px={2} py={1} spacing={1}>
                <Typography fontSize={20} fontWeight={700}>{t('advancedSearch', {ns: NS_TRANS.MAIN})}</Typography>
                {/* Thời gian diễn ra cuộc họp */}
                <ItemFilter title={t('title.time')}>
                    <WeekPicker setDiffTime={setDiffTime} type={currentTypeView} handleChangeTimeInCalendar={handleChangeTimeInCalendar}/>
                </ItemFilter>
                {/* Phân loại cuộc họp */}
                <ItemFilter title={t('title.type')}>
                    <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                        <FormControlLabel control={<Checkbox defaultChecked />} label={t('mnMeeting.myCalendar')} />
                        <FormControlLabel control={<Checkbox defaultChecked />} label={t('mnMeeting.invitedCalendar')} />
                        <FormControlLabel control={<Checkbox defaultChecked />} label={t('mnMeeting.otherCalender')} />
                    </FormGroup>
                </ItemFilter>
                {/* Trạng thái cuộc họp */}
                <ItemFilter isLast={true} title={"Trạng thái"}>
                    <FormGroup sx={{ display: 'flex', flexDirection: 'column' }}>
                        <FormControlLabel control={<Checkbox defaultChecked />} label={t('mnMeeting.incoming')} />
                        <FormControlLabel control={<Checkbox defaultChecked />} label={t('mnMeeting.inprogressing')} />
                        <FormControlLabel control={<Checkbox defaultChecked />} label={t('mnMeeting.ended')} />
                        <FormControlLabel control={<Checkbox defaultChecked />} label={t('mnMeeting.canceled')} />
                    </FormGroup>
                </ItemFilter>
            </Stack>
            {/* Hành động tìm kiếm */}
            <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <Button variant='outlined' onClick={() => alert("Reset success!!!")}>{t('actions.reset')}</Button>
                <Button onClick={() => alert("Apply success!!!")}>{t('actions.confirm')}</Button>
            </Box>
        </Box>
    )
}

export default FilterMeeting